/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function createMissingInvoices (params?: { id?: number }) {
  return rest.put('/api/invoices/generate-missing', {
    body: JSON.stringify(params),
    headers: { 'content-type': 'application/json' }
  })
    .then((resp) => resp.json())
}

export function deleteInvoice (id: number, params?: {
  deleteGeneratedTransactions: true,
  deleteManualTransactions: false,
  deletePaidTransactions: false
}) {
  return rest.delete(`/api/invoices/${id}?${stringify(params)}`)
}

export async function downloadInvoicesArchive (params?: { ids?: number[] } & Record<string, any>) {
  return rest.post('/api/invoices/download', {
    body: JSON.stringify(params),
    headers: { 'content-type': 'application/json' }
  })
    .then(handleBlobResponse)
}

export function fetchInvoice (id: number): Promise<Invoice> {
  return rest.get(`/api/invoices/${id}`)
    .then((resp) => resp.json())
}

export function fetchInvoiceCount (params?: {
  status: InvoiceStatus;
  type?: InvoiceType;
}): Promise<{ count: number }> {
  return rest.get(`/api/invoices/count?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyInvoices (params?: Record<string, any>): Promise<HalDocument<{
  invoices: Invoice[]
}>> {
  return rest.get(`/api/invoices?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyMonthsWithInvoices (params?: { leaseId: number }) {
  return rest.get(`/api/invoices/months?${stringify(params)}`)
    .then((resp) => resp.json() as Promise<{
      data: { year: number, month: number, count: number }[]
    }>)
    .then((r) => r.data)
}

export function patchInvoice (id: number, data: Partial<Invoice>) {
  return rest.patch(`/api/invoices/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postInvoice (data: Partial<Invoice>) {
  return rest.post('/api/invoices', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
